<div class="loader-wrapper" *ngIf="showLoader()">
    <div class="loader-background"></div>
    <div class="loader"></div>
</div>
